var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"worksModal","click-to-close":false,"width":645,"height":506},on:{"before-open":_vm.beforeOpen}},[_c('works-content',_vm._b({ref:"content"},'works-content',_vm.callbacks,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }